import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from 'src/containers/NavBar';
import SubNav from 'src/containers/SubNav';
import PageContainer from 'src/components/PageContainer';
import ReportsChp from 'src/containers/Reports/Chp';
import Macra2025 from 'src/containers/Reports/Macra/2025';
import Macra2026 from 'src/containers/Reports/Macra/2026';

function ReportsContainer() {
    const location = useLocation();

    function getCurrentReport() {
        if (location.pathname.includes('chp')) {
            return <ReportsChp />;
        } else if (location.pathname.includes('macra/2025')) {
            return <Macra2025 />;
        } else if (location.pathname.includes('macra')) {
            return <Macra2026 />;
        }
    }

    return (
        <PageContainer>
            <NavBar />
            <SubNav type="reports" />
            {getCurrentReport()}
        </PageContainer>
    );
}

export default ReportsContainer;
